<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-12">
                <div class="card-widget">
                    <div class="card-widget-title">
                        <div class="card-widget-title-label">
                            <h3>{{$t('Device list')}}</h3>
                        </div>
                    </div>
                    <div class="card-widget-content" v-if="customer">
                      <devices-list :customer="customer" :can-modify-columns="false" :columns="['device_type','update','maintenance_contract_active',]"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

  <script>
  import axios from 'axios'
  import DevicesList from "../components/DevicesList.vue";

  export default {
          name: 'CustomerDevices',
          components: {DevicesList},
          props: {
          },
          data: () => ({
              loading: true,
              customer: null,

          }),
          mounted() {
              this.loadCustomer()
          },
          methods: {
              loadCustomer() {
                  let url = this.$store.getters.getAppUrl + '/dealer/api/v2/customers/' + this.$route.params.customer_id
                  axios.get(url)
                      .then(({ data }) => {
                          this.customer = data.data;
                          this.loading = false;
                      })
                      .catch(function (error) {
                          console.log(error.stack);
                      });
              },

          }
      }
  </script>
